module.exports = __webpack_public_path__ + "img/114.f759da91.jpg";